module.exports = __webpack_public_path__ + "img/valencia_ayora.eb48c1ca.jpg";